import { render, staticRenderFns } from "./EditWidget.vue?vue&type=template&id=ace5e8ec&"
import script from "./EditWidget.vue?vue&type=script&lang=js&"
export * from "./EditWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports